/* src/app/components/dashboard/dashboard.component.scss */
.mat-mdc-card-content {
  --margin: 100px;
}
/*# sourceMappingURL=dashboard.component.css.map */
